import { JSX } from "react";

function SegmentSeparator(): JSX.Element {
  return <i className="fa fa-angle-double-right mlr5" />;
}

export { SegmentSeparator };
